import moment from 'moment-timezone';

export interface CalendarDatesChanged {
  current: Date;
  start: Date;
  end: Date;
  formattedRange: string;
}

export interface BreakOccurrence {
  id: number;
  startDate: moment.Moment;
  priority: number;
}

export interface BreakList {
  id: number;
  name: string;
  color: string;
  occurrences?: BreakOccurrence[];
  priority?: number;
}

export interface BreakListBreak {
  id: number;
  color: string;
  name: string;
}

export interface BreakListOccurrence {
  occurrenceId: number;
  breakId: number;
  startDate: moment.Moment;
  priority: number;
}

export interface BreakListHoursOccurrences {
  startHour: string;
  hour24h?: string;
  occurrences: BreakListOccurrence[][];
}

export interface BreakList2 {
  breaks: BreakListBreak[];
  occurrences: BreakListHoursOccurrences[];
}

export interface BreakRepeatDays {
  repeatEndDay: moment.Moment;
  repeatDays: string;
}

export interface BreakRepeatPerDay {
  repeatInterval: number;
  repeatEndHour: string;
}

export enum BreakKind {
  program = 'program',
  playlist = 'playlist',
  track = 'track',
}

export type BreakPlayType = 'sequential' | 'random';

export interface BreakDetails {
  id?: number;
  trackId?: number;
  programId?: number;
  playlistId?: number;
  kind: BreakKind;
  startHour: string;
  startDay: moment.Moment;
  playType: BreakPlayType;
  tracksCount: number;
  priority: number;
  fixedTime: boolean;
  tolerance: number;
  dailyRepeat: boolean;
  repeat: BreakRepeatDays;
  repeatPerDay: BreakRepeatPerDay;
}

export interface BreakDetailsAndOcc {
  break: BreakDetails;
  breakName: string;
  occurrence: number;
  mobile?: boolean;
}
